/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.28/esri/copyright.txt for details.
*/
import{Graphics3DSymbol as o}from"./Graphics3DSymbol.js";import{Graphics3DWebStyleSymbol as r}from"./Graphics3DWebStyleSymbol.js";function i(i){return i instanceof r?i.graphics3DSymbol:i instanceof o?i:null}export{i as getGraphics3DSymbol};
